import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getHistory } from 'js/history';

const withRouter = (Component) => {
  const ComponentWithRouterProp = React.forwardRef((props, ref) => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const originalHistory = getHistory();

    // Intercept history.push and history.replace to ensure that object-based query strings ('search') always start with a '?'
    const history = React.useMemo(() => {
      const safeNavigate = (method) => (to, state) => {
        if (typeof method !== 'function') return;
        // If an object is passed (like { pathname: '...', search: '...' }) and 'search' is missing the leading '?', we automatically inject it.
        if (to && typeof to === 'object' && to.search && !to.search.startsWith('?')) {
          return method({ ...to, search: `?${to.search}` }, state);
        }
        return method(to, state);
      };

      // Fallback to an empty object if originalHistory is null
      const safeHistory = originalHistory || {};

      return {
        ...safeHistory,
        push: safeNavigate(safeHistory.push),
        replace: safeNavigate(safeHistory.replace),
      };
    }, [originalHistory]);

    return (
      <Component
        {...props}
        ref={ref} // Pass the ref to the wrapped component
        location={location}
        routeParams={params}
        navigate={navigate}
        history={history}
      />
    );
  });
  ComponentWithRouterProp.displayName = 'ComponentWithRouterProp';
  return ComponentWithRouterProp;
};
export default withRouter;
